<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                         <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" :height="height" row-key="id" border
                :tree-props="{children: 'child'}">
                <el-table-column prop="id" label="编号"></el-table-column>
                <el-table-column prop="name" label="类别"></el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="add_by" label="添加人"></el-table-column>
                <el-table-column label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <el-dialog title="类别设置" :visible.sync="dialogVisible" center width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="上级类别名称" prop='sz_type'>
                        <el-select v-model="ruleForm.sz_type" placeholder="请选择" size="small">
                            <el-option v-for="item in lb_options" :key="item.id"
                                :label="item.name_2?item.name_2:item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类别名称" prop='sz_name'>
                        <el-input v-model="ruleForm.sz_name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForm.sz_sort" size="small" type="number"> </el-input>
                    </el-form-item>
                   <el-form-item label="图片" required>
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                            :headers="{ 'token':$store.state.user.token }"
                            :data="{ image_class_id:'72',file_type:'1' }"
                            :file-list="ruleForm.lb_mapList"  :on-success="uploadSuccess"
                            :limit="1" :on-remove="uploadRmove" list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <!-- <el-form-item label="标题">
                        <el-input v-model="ruleForm.seo_title" size="small" type="text"> </el-input>
                    </el-form-item>
                    <el-form-item label="关键词">
                        <el-input v-model="ruleForm.seo_keyword" size="small" type="text"> </el-input>
                    </el-form-item>
                    <el-form-item label="描述">
                        <el-input v-model="ruleForm.seo_describe" size="small" type="textarea" :rows="2"> </el-input>
                    </el-form-item> -->
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
       

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                lb_options: [],
                currentPage: 1,
                pagesize: 15,
                height: null,
                // 
                eid: '0',
                dialogVisible: false,
                subloading: false,
                ruleForm: {
                    sz_type: '',
                    sz_name: '',
                    sz_sort: 50,
                    seo_describe: '',
                    seo_keyword: '',
                    seo_title: '',
                    lb_mapList:[]
                },
                rule: {
                    sz_name: [{
                        required: true,
                        message: '请填写类别名称',
                        trigger: 'blur'
                    }],
                },
                uploading: false,
                updateVisible: false,
                updatetype: 1,
                updatetype_id: 0,
                homeseo: {
                    seo_description: '',
                    seo_keywords: '',
                    seo_title: '',
                },
                seorule: {
                    seo_description: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    }],
                    seo_keywords: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    }],
                    seo_title: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    }],
                },
                seotype: 0,
                seoVisible: false,
                mapListed:[],

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.gettype()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 175 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 175 + 'px'
                }
            },
            //下拉框
            gettype() {
                let that = this
                that.lb_options = []
                axios.post("/admin/communityDoctor/categorySelect", {}, {
                        token: true
                    })
                    .then(response => {
                        var arr = [{
                            id: 0,
                            name_2: '顶级类别'
                        }]
                        that.lb_options = arr.concat(response.data.data)
                        this.ruleForm.sz_type=0
                    })
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post("/admin/communityDoctor/categoryHead", {}, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = '0'
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.sz_name = ''
                that.ruleForm.sz_sort = 50
                that.ruleForm.seo_title = ''
                that.ruleForm.seo_keyword = ''
                that.ruleForm.seo_describe = ''

                
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.ruleForm.sz_type!=0&&this.mapListed.length==0)return this.$message('请上传图片')
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/communityDoctor/update"
                        } else {
                            urls = "/admin/communityDoctor/save"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                name: that.ruleForm.sz_name,
                                author: this.user.id,
                                pid: this.ruleForm.sz_type,
                                sort: that.ruleForm.sz_sort,
                                image:this.mapListed.length>0?this.mapListed[0].url:''
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                    that.gettype()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/communityDoctor/read", {
                        id: that.eid,
                        author: this.user.id,
                        name: that.ruleForm.sz_name,
                        pid: this.ruleForm.sz_type,

                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        that.ruleForm.sz_name = data.name
                        that.ruleForm.sz_type = data.pid
                        that.ruleForm.sz_sort = data.sort
                        this.mapListed=data.image?[{url:data.image}]:[]
                        this.ruleForm.lb_mapList=data.image?[{url:data.image}]:[]
                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/communityDoctor/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                                 that.gettype()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
          
          
            
        },

    };
</script>


<style scoped>
</style>